import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../../auth/stores/authStore';
import { getWeeklyAllocationTrend } from '../api/dashboardApi';
import { dashboardKeys } from './dashboardKeys';

export function useGetWeeklyAllocationTrend() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: dashboardKeys.weeklyAllocationTrend(),
    queryFn: getWeeklyAllocationTrend,
    enabled: isAuthenticated,
    staleTime: 30 * 1000,
  });
}
